module.exports = __webpack_public_path__ + "img/alarm.ad0291f8.gif";